/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * When the value of the status field is "failed", this field may have a value.
 * If so the value describes an actionable reason why the payment failed
 * 
 * authorization_revoked:
 *     Payment declined because the authorization has been revoked, e.g., for a
 *     recurring card payment agreement, the card issuer may have revoked the
 *     authorization for a Network Transaction Reference (NTR).
 *     Payments should not be retried with that NTR because a new NTR, meaning a
 *     new recurring agreement, is needed to resume payments.
 * 
 * verification_required:
 *     Payment declined because the issuing bank requires verification, e.g.
 *     BankID/3DS. Use the Start Verification operation to start a verification.
 *     Once the verification has been completed, the payment can be retried by
 *     calling Create Payment again with the exact same parameters as the first
 *     attempt except the ID (when a payment fails, a new payment ID must always
 *     be used for each subsequent retry). The verifcation token obtained from
 *     the verification process is to be sent in the
 *     "Vipps-Payment-Verification-Token" of the Create Payment call, as usual.
 * 
 * invalid_card:
 *     The user tried to pay using a card that has either expired or is disabeled
 *     by the issuer.
 * 
 * insufficient_funds:
 *     Payment was declined by the payer bank due to lack of funds.
 * 
 * invalid_kid, kid_not_supported, kid_required:
 *     There is a discrepancy between the use of KID and the requrements
 *     of the invoice issuer
 * 
 * invalid_debit_account:
 *     There is some issue with using this account for invoice payments
 * 
 * credit_not_allowed:
 *     Credut cards are not allowed to be used towards this salesunit
 * 
 * country_not_allowed:
 *     FSCP - The issuing country is not supported, and the transaction has been rejected
 * @export
 */
export const FailureReason = {
    AuthorizationRevoked: 'authorization_revoked',
    VerificationRequired: 'verification_required',
    InvalidCard: 'invalid_card',
    InsufficientFunds: 'insufficient_funds',
    InvalidKid: 'invalid_kid',
    KidNotSupported: 'kid_not_supported',
    KidRequired: 'kid_required',
    InvalidDebitAccount: 'invalid_debit_account',
    CreditNotAllowed: 'credit_not_allowed',
    CountryNotAllowed: 'country_not_allowed'
} as const;
export type FailureReason = typeof FailureReason[keyof typeof FailureReason];


export function FailureReasonFromJSON(json: any): FailureReason {
    return FailureReasonFromJSONTyped(json, false);
}

export function FailureReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureReason {
    return json as FailureReason;
}

export function FailureReasonToJSON(value?: FailureReason | null): any {
    return value as any;
}

